// This is used to be able to search through the URL,

// and be able to find relevant parts of it;
export const companySlug = "company" as const;
export const ssqSlug = "ssq" as const;
export const headingSlug = "headings" as const;

export const productSlug = "products" as const;
export const intermediateProductSlug = "intermediate-products" as const;
export const ingredientSlug = "ingredients" as const;
export const ingredientSupplierSlug = "supplier" as const;
export const packagingSlug = "packagings" as const;
export const supplierSlug = "suppliers" as const;
export const distributionSlug = "distribution" as const;
export const transportSlug = "transport" as const;
export const transformationSlug = "transformations" as const;
export const CMSSlug = "pages" as const;

export const SettingsSlug = "settings" as const;
export const CsrStrategySlug = "csrStrategy" as const;
export const campaignSlug = "campaign" as const;

export const loginSlug = "login" as const;
export const logoutSlug = "logout" as const;
export const noCompanySlug = "noCompany" as const;
export const consentsSlug = "consents" as const;

export const documentationSlug = "documentation" as const;
export const networkSlug = "network" as const;

const settingsPath = (...segments: string[]) => `/${[SettingsSlug, ...segments].filter(Boolean).join("/")}` as const;

const ActionRoutes = {
    noActionPlan: (companyId: number, ssqId: number) =>
        `/${companySlug}/${companyId}/${ssqSlug}/${ssqId}/actions/noActionPlan` as const,
    trajectory: (companyId: number, ssqId: number) =>
        `/${companySlug}/${companyId}/${ssqSlug}/${ssqId}/actions/trajectory` as const,
    trajectoryBarChart: (companyId: number, ssqId: number) =>
        `/${companySlug}/${companyId}/${ssqSlug}/${ssqId}/actions/trajectory/barChart` as const,
    trajectoryCards: (companyId: number, ssqId: number) =>
        `/${companySlug}/${companyId}/${ssqSlug}/${ssqId}/actions/trajectory/cards` as const,
    planning: (companyId: number, ssqId: number) =>
        `/${companySlug}/${companyId}/${ssqSlug}/${ssqId}/actions/planning` as const,
    editPlanning: (companyId: number, ssqId: number, actionId: string) =>
        `/${companySlug}/${companyId}/${ssqSlug}/${ssqId}/actions/planning/${actionId}` as const,
    catalog: (companyId: number, ssqId: number) =>
        `/${companySlug}/${companyId}/${ssqSlug}/${ssqId}/actions/catalog` as const,

    // Deprecated
    catalogList: (companyId: number, ssqId: number) =>
        `/${companySlug}/${companyId}/${ssqSlug}/${ssqId}/actions/catalog/list` as const,

    catalogGroup: (companyId: number, ssqId: number, groupId: number) =>
        `/${companySlug}/${companyId}/${ssqSlug}/${ssqId}/actions/catalog/${groupId}` as const,
    catalogGroupItem: (companyId: number, ssqId: number, groupId: number, actionId: number) =>
        `/${companySlug}/${companyId}/${ssqSlug}/${ssqId}/actions/catalog/${groupId}/action/${actionId}` as const,

    editCatalog: (companyId: number, ssqId: number, actionId: string) =>
        `/${companySlug}/${companyId}/${ssqSlug}/${ssqId}/actions/catalog/list/${actionId}` as const,
};

const ProductRoutes = {
    list: (companyId: number) => `/${companySlug}/${companyId}/${productSlug}` as const,

    valueChainsList: (companyId: number) => `/${companySlug}/${companyId}/${productSlug}/value-chains` as const,

    create: (companyId: number, startingPageId?: number) =>
        `/${companySlug}/${companyId}/${productSlug}/new/${startingPageId ?? 0}` as const,

    edit: (companyId: number, productId: number, startingPageId?: number) =>
        `/${companySlug}/${companyId}/${productSlug}/${productId}/edit/${startingPageId ?? 0}` as const,

    view: (companyId: number, productId: number) =>
        `/${companySlug}/${companyId}/${productSlug}/${productId}/details` as const,

    scores: (companyId: number, productId: number) =>
        `/${companySlug}/${companyId}/${productSlug}/${productId}/details/scores` as const,

    score: (companyId: number, productId: number, scoreId: number) =>
        `/${companySlug}/${companyId}/${productSlug}/${productId}/details/scores/${scoreId}` as const,

    scoreDistribution: (companyId: number, productId: number, scoreId: number) =>
        `/${companySlug}/${companyId}/${productSlug}/${productId}/details/scores/${scoreId}/distribution` as const,

    activity: (companyId: number, productId: number) =>
        `/${companySlug}/${companyId}/${productSlug}/${productId}/details/activities` as const,

    information: (companyId: number, productId: number) =>
        `/${companySlug}/${companyId}/${productSlug}/${productId}/details/informations` as const,

    valueChain: (companyId: number, productId: number) =>
        `/${companySlug}/${companyId}/${productSlug}/${productId}/details/value-chain` as const,

    ssq: (companyId: number, productId: number) =>
        `/${companySlug}/${companyId}/${productSlug}/${productId}/details/questionnaire` as const,

    ssqSummary: (companyId: number, productId: number) =>
        `/${companySlug}/${companyId}/${productSlug}/${productId}/details/questionnaire/summary` as const,

    ssqProduct: (companyId: number, productId: number, productCompanyId?: number | undefined) => {
        const noProductCompanyUrl =
            `/${companySlug}/${companyId}/${productSlug}/${productId}/details/questionnaire/product` as const;
        if (productCompanyId === undefined) {
            return noProductCompanyUrl;
        }

        return `${noProductCompanyUrl}/${companySlug}/${productCompanyId}` as const;
    },

    ssqIngredients: (companyId: number, productId: number) =>
        `/${companySlug}/${companyId}/${productSlug}/${productId}/details/questionnaire/ingredients` as const,

    ssqPackagings: (companyId: number, productId: number) =>
        `/${companySlug}/${companyId}/${productSlug}/${productId}/details/questionnaire/packagings` as const,

    ssqHeading: (companyId: number, productId: number, productCompanyId: number, headingId: number) =>
        `/${companySlug}/${companyId}/${productSlug}/${productId}/details/questionnaire/company/${productCompanyId}/edit/${headingId}` as const,
} as const;

const IntermediateProductRoutes = {
    list: (companyId: number) => `/${companySlug}/${companyId}/${intermediateProductSlug}` as const,

    valueChainsList: (companyId: number) => `/${companySlug}/${companyId}/${productSlug}/value-chains` as const,

    create: (companyId: number, startingPageId?: number) =>
        `/${companySlug}/${companyId}/${intermediateProductSlug}/new/${startingPageId ?? 0}` as const,

    edit: (companyId: number, productId: number, startingPageId?: number) =>
        `/${companySlug}/${companyId}/${intermediateProductSlug}/${productId}/edit/${startingPageId ?? 0}` as const,

    view: (companyId: number, productId: number) =>
        `/${companySlug}/${companyId}/${intermediateProductSlug}/${productId}/details` as const,

    scores: (companyId: number, productId: number) =>
        `/${companySlug}/${companyId}/${intermediateProductSlug}/${productId}/details/scores` as const,

    score: (companyId: number, productId: number, scoreId: number) =>
        `/${companySlug}/${companyId}/${intermediateProductSlug}/${productId}/details/scores/${scoreId}` as const,

    scoreDistribution: (companyId: number, productId: number, scoreId: number) =>
        `/${companySlug}/${companyId}/${intermediateProductSlug}/${productId}/details/scores/${scoreId}/distribution` as const,

    activity: (companyId: number, productId: number) =>
        `/${companySlug}/${companyId}/${intermediateProductSlug}/${productId}/details/activities` as const,

    information: (companyId: number, productId: number) =>
        `/${companySlug}/${companyId}/${intermediateProductSlug}/${productId}/details/informations` as const,

    valueChain: (companyId: number, productId: number) =>
        `/${companySlug}/${companyId}/${intermediateProductSlug}/${productId}/details/value-chain` as const,

    ssq: (companyId: number, productId: number) =>
        `/${companySlug}/${companyId}/${intermediateProductSlug}/${productId}/details/questionnaire` as const,

    ssqSummary: (companyId: number, productId: number) =>
        `/${companySlug}/${companyId}/${intermediateProductSlug}/${productId}/details/questionnaire/summary` as const,

    ssqProduct: (companyId: number, productId: number, productCompanyId?: number | undefined) => {
        const noProductCompanyUrl =
            `/${companySlug}/${companyId}/${intermediateProductSlug}/${productId}/details/questionnaire/product` as const;
        if (productCompanyId === undefined) {
            return noProductCompanyUrl;
        }

        return `${noProductCompanyUrl}/${companySlug}/${productCompanyId}` as const;
    },

    ssqIngredients: (companyId: number, productId: number) =>
        `/${companySlug}/${companyId}/${intermediateProductSlug}/${productId}/details/questionnaire/ingredients` as const,

    ssqPackagings: (companyId: number, productId: number) =>
        `/${companySlug}/${companyId}/${intermediateProductSlug}/${productId}/details/questionnaire/packagings` as const,

    ssqHeading: (companyId: number, productId: number, productCompanyId: number, headingId: number) =>
        `/${companySlug}/${companyId}/${intermediateProductSlug}/${productId}/details/questionnaire/company/${productCompanyId}/edit/${headingId}` as const,
} as const;

const IngredientRoutes = {
    list: (companyId: number) => `/${companySlug}/${companyId}/${ingredientSlug}` as const,

    create: (companyId: number, startingPageId?: number) =>
        `/${companySlug}/${companyId}/${ingredientSlug}/new/${startingPageId ?? 0}` as const,

    edit: (companyId: number, ingredientId: number, startingPageId?: number) =>
        `/${companySlug}/${companyId}/${ingredientSlug}/${ingredientId}/edit/${startingPageId ?? 0}` as const,

    view: (companyId: number, ingredientId: number) =>
        `/${companySlug}/${companyId}/${ingredientSlug}/${ingredientId}` as const,

    scores: (companyId: number, ingredientId: number) =>
        `/${companySlug}/${companyId}/${ingredientSlug}/${ingredientId}/scores` as const,

    score: (companyId: number, ingredientId: number, scoreId: number) =>
        `/${companySlug}/${companyId}/${ingredientSlug}/${ingredientId}/scores/${scoreId}` as const,

    scoreDistribution: (companyId: number, ingredientId: number, scoreId: string) =>
        `/${companySlug}/${companyId}/${ingredientSlug}/${ingredientId}/scores/${scoreId}/distribution` as const,

    activity: (companyId: number, ingredientId: number) =>
        `/${companySlug}/${companyId}/${ingredientSlug}/${ingredientId}/activities` as const,

    information: (companyId: number, ingredientId: number) =>
        `/${companySlug}/${companyId}/${ingredientSlug}/${ingredientId}/informations` as const,

    valueChain: (companyId: number, ingredientId: number) =>
        `/${companySlug}/${companyId}/${ingredientSlug}/${ingredientId}/value-chain` as const,

    ssq: (companyId: number, ingredientId: number, supplierId: number | undefined) => {
        const noSupplierUrl = `/${companySlug}/${companyId}/${ingredientSlug}/${ingredientId}/questionnaire` as const;
        if (supplierId === undefined) {
            return noSupplierUrl;
        }

        const supplierUrl = `${noSupplierUrl}/${ingredientSupplierSlug}/${supplierId}` as const;
        return supplierUrl;
    },

    ssqHeading: (companyId: number, ingredientId: number, supplierId: number, headingId: number) =>
        `/${companySlug}/${companyId}/${ingredientSlug}/${ingredientId}/questionnaire/${ingredientSupplierSlug}/${supplierId}/edit/${headingId}` as const,
} as const;

const PackagingRoutes = {
    list: (companyId: number) => `/${companySlug}/${companyId}/${packagingSlug}` as const,

    /** Direct shortcut to the elementary creation form. */
    createElement: (companyId: number) => `/${companySlug}/${companyId}/${packagingSlug}/new/element` as const,

    /** Direct shortcut to the composite creation form. */
    createComposite: (companyId: number) => `/${companySlug}/${companyId}/${packagingSlug}/new/composite` as const,

    edit: (companyId: number, packagingId: number, startingPageId?: number) =>
        `/${companySlug}/${companyId}/${packagingSlug}/${packagingId}/edit/${startingPageId ?? 0}` as const,

    view: (companyId: number, packagingId: number) =>
        `/${companySlug}/${companyId}/${packagingSlug}/${packagingId}` as const,

    scores: (companyId: number, packagingId: number) =>
        `/${companySlug}/${companyId}/${packagingSlug}/${packagingId}/scores` as const,

    score: (companyId: number, packagingId: number, scoreId: number) =>
        `/${companySlug}/${companyId}/${packagingSlug}/${packagingId}/scores/${scoreId}` as const,

    scoreDistribution: (companyId: number, packagingId: number, scoreId: string) =>
        `/${companySlug}/${companyId}/${packagingSlug}/${packagingId}/scores/${scoreId}/distribution` as const,

    information: (companyId: number, packagingId: number) =>
        `/${companySlug}/${companyId}/${packagingSlug}/${packagingId}/informations` as const,

    ssq: (companyId: number, packagingId: number) =>
        `/${companySlug}/${companyId}/${packagingSlug}/${packagingId}/questionnaire` as const,

    ssqHeading: (companyId: number, packagingId: number, headingId: number) =>
        `/${companySlug}/${companyId}/${packagingSlug}/${packagingId}/questionnaire/edit/${headingId}` as const,
} as const;

const SupplierRoutes = {
    list: (companyId: number) => `/${companySlug}/${companyId}/${supplierSlug}/` as const,

    create: (companyId: number, startingPageId?: number) =>
        `/${companySlug}/${companyId}/${supplierSlug}/new/${startingPageId ?? 0}` as const,

    edit: (companyId: number, supplierId: number, startingPageId?: number) =>
        `/${companySlug}/${companyId}/${supplierSlug}/${supplierId}/edit/${startingPageId ?? 0}` as const,
};

const TransportRoutes = {
    list: (companyId: number) => `/${companySlug}/${companyId}/${transportSlug}` as const,
    newLeg: (companyId: number) => `/${companySlug}/${companyId}/${transportSlug}/legs/new` as const,
    editLeg: (companyId: number, legId: number) =>
        `/${companySlug}/${companyId}/${transportSlug}/legs/${legId}/edit` as const,
    newCircuit: (companyId: number) => `/${companySlug}/${companyId}/${transportSlug}/circuits/new` as const,
    editCircuit: (companyId: number, circuitId: number) =>
        `/${companySlug}/${companyId}/${transportSlug}/circuits/${circuitId}/edit` as const,
};

const DistributionRoutes = {
    list: (companyId: number) => `/${companySlug}/${companyId}/${distributionSlug}` as const,
};

const TransformationRoutes = {
    list: (companyId: number) => `/${companySlug}/${companyId}/${transformationSlug}` as const,
};

const CompanyRoutes = {
    overview: (companyId: number) => `/${companySlug}/${companyId}/overview` as const,
    network: (companyId: number) => `/${companySlug}/${companyId}/${networkSlug}` as const,
    overviewScore: (companyId: number, scoreId: number) => `/${companySlug}/${companyId}/overview/${scoreId}` as const,
    overviewSsq: (companyId: number, ssqId: number, scoreId?: number) =>
        `/${companySlug}/${companyId}/overview/${ssqId}${scoreId === undefined ? "" : `?score-${scoreId}-tab=0`}` as const,

    // Routes générales (pour compatibilité ou vue agrégée)
    scores: (companyId: number) => `/${companySlug}/${companyId}/scores` as const,

    // Routes spécifiques par QSS et campagne
    ssqScores: (companyId: number, ssqId: number, campaignId: number) =>
        `/${companySlug}/${companyId}/${ssqSlug}/${ssqId}/${campaignSlug}/${campaignId}/scores` as const,
    ssqScore: (companyId: number, ssqId: number, campaignId: number, scoreId: number) =>
        `/${companySlug}/${companyId}/${ssqSlug}/${ssqId}/${campaignSlug}/${campaignId}/scores/${scoreId}` as const,
    ssqScoreDistribution: (companyId: number, ssqId: number, campaignId: number, scoreId: string) =>
        `/${companySlug}/${companyId}/${ssqSlug}/${ssqId}/${campaignSlug}/${campaignId}/scores/${scoreId}/distribution` as const,
    ssqScoreComparison: (companyId: number, ssqId: number, campaignId: number, scoreId: string) =>
        `/${companySlug}/${companyId}/${ssqSlug}/${ssqId}/${campaignSlug}/${campaignId}/scores/${scoreId}/comparison` as const,
    ssqScoreEvolution: (companyId: number, ssqId: number, campaignId: number, scoreId: string) =>
        `/${companySlug}/${companyId}/${ssqSlug}/${ssqId}/${campaignSlug}/${campaignId}/scores/${scoreId}/evolution` as const,

    synthesis: (companyId: number) => `/${companySlug}/${companyId}/synthese` as const,
    questionnaire: (companyId: number) => `/${companySlug}/${companyId}/questionnaire` as const,
    ssq: (companyId: number, ssqId: number, campaignId: number) =>
        `/${companySlug}/${companyId}/${ssqSlug}/${ssqId}/${campaignSlug}/${campaignId}/questionnaire` as const,
    ssqHeading: (companyId: number, ssqId: number, campaignId: number, headingId: number) =>
        `/${companySlug}/${companyId}/${ssqSlug}/${ssqId}/${campaignSlug}/${campaignId}/questionnaire/edit/${headingId}` as const,

    questionnaireScore: (companyId: number, ssqId: number, campaignId: number, scoreId: string) =>
        `/${companySlug}/${companyId}/${ssqSlug}/${ssqId}/${campaignSlug}/${campaignId}/scores/${scoreId}/questionnaire` as const,
    questionnaireHeading: (companyId: number, ssqId: number, campaignId: number, scoreId: string, headingId: number) =>
        `/${companySlug}/${companyId}/${ssqSlug}/${ssqId}/${campaignSlug}/${campaignId}/scores/${scoreId}/questionnaire/${headingSlug}/${headingId}` as const,

    requirements: (companyId: number) => `/${companySlug}/${companyId}/requirements` as const,
    comparison: (companyId: number) => `/${companySlug}/${companyId}/comparison` as const,

    actions: ActionRoutes,
} as const;

const SettingsRoutes = {
    list: () => `/${SettingsSlug}` as const,
    scores: () => `/${SettingsSlug}/scores` as const,
    jsonAttributes: () => `/${SettingsSlug}/additional-object-parameters` as const,
    cohortDefinitions: () => `/${SettingsSlug}/my-organization/custom-data-taxonomies/cohort-definitions` as const,
    entityTargetScoreAssignments: () => `/${SettingsSlug}/entity-target-score-assignment` as const,
    dataListsValuesOverrides: () => `/${SettingsSlug}/data-lists-values-overrides` as const,
    configuration: () => `/${SettingsSlug}/configuration` as const,
    configurationPath: (...segments: string[]) => settingsPath("configuration", ...segments),
    content: () => `/${SettingsSlug}/content` as const,
    references: () => `/${SettingsSlug}/references` as const,
    referencesPath: (...segments: string[]) => settingsPath("references", ...segments),
    features: () => `/${SettingsSlug}/features` as const,
    myOrganization: () => `/${SettingsSlug}/my-organization` as const,
    consentGovernance: () => `/${SettingsSlug}/configuration/access-permissions/consent-governance` as const,
    auditLog: () => `/${SettingsSlug}/configuration/access-permissions/audit-log` as const,
    myOrganizationPath: (...segments: string[]) => settingsPath("my-organization", ...segments),
    myOrganizationSection: (sectionId: string) => `/${SettingsSlug}/my-organization/${sectionId}` as const,

    // Gamme
    productLine: {
        list: () => `/${SettingsSlug}/product-line` as const,
        create: () => `/${SettingsSlug}/product-line/create` as const,
        edit: (productId: number) => `/${SettingsSlug}/product-line/${productId}/edit` as const,
    } as const,

    // Fillière
    ingredientLine: {
        list: () => `/${SettingsSlug}/ingredient-line` as const,
        create: () => `/${SettingsSlug}/ingredient-line/create` as const,
        edit: (ingId: number) => `/${SettingsSlug}/ingredient-line/${ingId}/edit` as const,
    } as const,
    companySectors: () => `/${SettingsSlug}/company-sectors` as const,
    organizationTypes: () => `/${SettingsSlug}/organization-types` as const,
    csrTheme: {
        list: () => `/${SettingsSlug}/csrTheme` as const,
        create: () => `/${SettingsSlug}/csrTheme/create` as const,
        edit: (csrId: number) => `/${SettingsSlug}/csrTheme/${csrId}/edit` as const,
    } as const,
    customTheme: {
        list: () => settingsPath("configuration", "customization-languages", "branding", "custom-themes"),
        create: () => settingsPath("configuration", "customization-languages", "branding", "custom-theme"),
        edit: (themeId: number) =>
            settingsPath(
                "configuration",
                "customization-languages",
                "branding",
                "custom-theme",
                "edit",
                themeId.toString(),
            ),
    } as const,
    companies: {
        view: (companyId: number) => `/${SettingsSlug}/companies/${companyId}` as const,
        list: () => `/${SettingsSlug}/companies` as const,
        create: () => `/${SettingsSlug}/companies/create` as const,
        edit: (companyId: number) => `/${SettingsSlug}/companies/${companyId}/edit` as const,
    } as const,
    providers: {
        list: () => `/${SettingsSlug}/providers` as const,
        create: () => `/${SettingsSlug}/providers/create` as const,
        edit: (providerId: number) => `/${SettingsSlug}/providers/${providerId}/edit` as const,
    } as const,
    users: {
        list: () => `/${SettingsSlug}/users` as const,
    } as const,
    packagings: {
        ssq: () => `/${SettingsSlug}/packagings/ssq` as const,
    } as const,

    appParams: () => `/${SettingsSlug}/applicationParameters` as const,
    brands: {
        list: () => `/${SettingsSlug}/brands` as const,
        create: () => `/${SettingsSlug}/brands/create` as const,
        edit: (brandId: number) => `/${SettingsSlug}/brands/${brandId}/edit` as const,
    } as const,

    roles: {
        list: () => `/${SettingsSlug}/roles` as const,
        create: () => `/${SettingsSlug}/roles/create` as const,
        edit: (roleId: string) => `/${SettingsSlug}/roles/${roleId}/edit` as const,
    } as const,

    permissions: {
        list: () => `/${SettingsSlug}/permissions` as const,
        create: () => `/${SettingsSlug}/permissions/create` as const,
        edit: (permissionId: string) => `/${SettingsSlug}/permissions/${permissionId}/edit` as const,
    } as const,

    applications: {
        list: () => `/${SettingsSlug}/applications` as const,
        create: () => `/${SettingsSlug}/applications/create` as const,
        edit: (applicationId: string) => `/${SettingsSlug}/applications/${applicationId}/edit` as const,
    } as const,

    integrations: () => `/${SettingsSlug}/integrations` as const,

    cms: {
        root: () => `/${SettingsSlug}/cms` as const,
        page: (pageId: string, isNew?: boolean) => `/${SettingsSlug}/cms/${pageId}${isNew ? "?new=true" : ""}` as const,
        templates: () => `/${SettingsSlug}/cms/templates` as const,
        dynablocks: () => `/${SettingsSlug}/cms/dynablocks` as const,
        editDynablock: (extensionId: number) => `/settings/cms/dynablocks/${extensionId}` as const,
    } as const,

    mediaLibrary: {
        root: () => `/${SettingsSlug}/content/media-library` as const,
    },

    icvs: {
        list: () => `/${SettingsSlug}/icvs` as const,
    },

    ingredientReferences: {
        list: () => `/${SettingsSlug}/ingredient-references` as const,
    },

    csrStrategy: {
        general: () => `/${SettingsSlug}/${CsrStrategySlug}/general` as const,
        pillars: () => `/${SettingsSlug}/${CsrStrategySlug}/pillars` as const,
        themes: () => `/${SettingsSlug}/${CsrStrategySlug}/themes` as const,
    },

    translations: {
        management: () => `/${SettingsSlug}/translations` as const,
    },

    languages: {
        management: () => `/${SettingsSlug}/languages` as const,
    },

    tags: {
        overview: () => `/${SettingsSlug}/tags` as const,
        tagTypes: {
            list: () => `/${SettingsSlug}/tags/types` as const,
            create: () => `/${SettingsSlug}/tags/types/create` as const,
            edit: (tagTypeId: string) => `/${SettingsSlug}/tags/types/${tagTypeId}/edit` as const,
            view: (tagTypeId: string) => `/${SettingsSlug}/tags/types/${tagTypeId}` as const,
        } as const,
        tagValues: {
            list: (tagTypeId?: string) =>
                tagTypeId ?
                    `/${SettingsSlug}/tags/values?tagType=${tagTypeId}`
                :   (`/${SettingsSlug}/tags/values` as const),
            create: (tagTypeId?: string) =>
                tagTypeId ?
                    `/${SettingsSlug}/tags/values/create?tagType=${tagTypeId}`
                :   (`/${SettingsSlug}/tags/values/create` as const),
            edit: (tagValueId: string) => `/${SettingsSlug}/tags/values/${tagValueId}/edit` as const,
            view: (tagValueId: string) => `/${SettingsSlug}/tags/values/${tagValueId}` as const,
        } as const,
        entityTags: {
            list: () => `/${SettingsSlug}/tags/entities` as const,
        } as const,
    } as const,

    questionnaires: {
        list: () => `/${SettingsSlug}/questionnaires` as const,
    } as const,

    theme: () => `/${SettingsSlug}/theme` as const,
    menuManagement: () => `/${SettingsSlug}/menu-management` as const,
    dataInvalidation: () => `/${SettingsSlug}/data-invalidation` as const,
} as const;

const Strategy = {
    list: () => `/strategy` as const,
} as const;

const ProfileSettingsRoutes = {
    root: () => `/profile-settings` as const,
    preferences: () => `/profile-settings?tab=preferences` as const,
} as const;

const CompanySettingsRoutes = {
    profile: () => `/company-settings` as const,
    payment: () => `/company-settings/payment` as const,
} as const;

const LoginRoutes = {
    logout: () => `/logout` as const,
    login: () => `/login` as const,
    noCompany: () => `/noCompany` as const,
    consents: () => `/consents` as const,
} as const;

const DocumentationRoutes = () => `/documentation` as const;

export const URLHandler = {
    home: () => "/" as const,
    login: LoginRoutes,

    company: CompanyRoutes,
    product: ProductRoutes,
    intermediateProduct: IntermediateProductRoutes,
    ingredient: IngredientRoutes,
    packaging: PackagingRoutes,
    supplier: SupplierRoutes,
    distribution: DistributionRoutes,
    transport: TransportRoutes,
    transformation: TransformationRoutes,
    settings: SettingsRoutes,

    profileSettings: ProfileSettingsRoutes,

    strategy: Strategy,
    companySettings: CompanySettingsRoutes,
    documentation: DocumentationRoutes,
} as const;
